import { z } from 'zod';

const pagination = z.object({
  total: z.number(),
  /**
   * Offset to request for the next page. Set by endpoints where one returned
   * item can cover several source rows, so `offset + limit` is not where the
   * next page starts — see ChatService.getMessages, which merges same-time
   * person events into one row. Absent on endpoints that map source rows 1:1.
   *
   * There is more to fetch exactly while `nextOffset < total`.
   */
  nextOffset: z.number().optional(),
});

const meta = z.object({
  pagination,
});

const paginated = <T extends z.ZodTypeAny>(data: T) =>
  z.object({
    meta,
    data: z.array(data),
  });

export type Paginated<T extends z.ZodTypeAny> = z.infer<
  ReturnType<typeof paginated<T>>
>;

export type PaginatedResult<T> = {
  meta: PaginatedMeta;
  data: T[];
};

export type PaginatedMeta = z.infer<typeof meta>;

export default paginated;
